import React from "react";
import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/table";

export function WebhooksModule({
  t,
  // State
  webhookEvents,
  webhookConfig,
  webhookNotifications,
  // Functions
  loadWebhookEvents,
  getEventCategoryColor,
  getEventCategoryName,
  getEventTypeEmoji,
  formatEventType,
  formatTimestampWithTimezone,
  renderJsonWithLinks,
  renderTextWithLinks
}) {
  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '16px'}}>
      <Card className="panel lightCard">
        <CardContent>
          <div className="panel-title darktxt" style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
            <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
              <span>🔗</span>
              {t('webhook_events_title')}
            </div>
            <Button onClick={loadWebhookEvents} variant="outline" size="sm">
              {t('webhook_events_refresh')}
            </Button>
          </div>
          <div className="small" style={{marginBottom: 16, color: '#6b7280'}}>
            Real-time Verkada Webhook Events für Ihren Account
          </div>

          {webhookEvents.length === 0 ? (
            <div style={{textAlign: 'center', padding: '40px 20px', color: '#6b7280'}}>
              <div style={{fontSize: '48px', marginBottom: '16px'}}>📭</div>
              <div>{t('webhook_events_empty')}</div>
            </div>
          ) : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>{t('webhook_events_type')}</TableHead>
                  <TableHead>{t('webhook_events_time')}</TableHead>
                  <TableHead>{t('webhook_events_notification_type')}</TableHead>
                  <TableHead>{t('webhook_events_actions')}</TableHead>
                  <TableHead>{t('webhook_events_payload')}</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {webhookEvents.map((event, index) => (
                  <TableRow key={event._id || index} style={{
                    backgroundColor: getEventCategoryColor(
                      event.payload?.data?.device_type ||
                      event.payload?.category ||
                      event.event_category ||
                      'general'
                    ).background
                  }}>
                    <TableCell style={{fontWeight: 'bold'}}>
                      <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                        <span style={{fontSize: '16px'}}>
                          {getEventTypeEmoji(
                            event.payload?.data?.notification_type || 
                            event.payload?.data?.event_type || 
                            event.payload?.webhook_type || 
                            event.event_type || 
                            'unknown',
                            event.payload?.data?.device_type || 
                            event.payload?.category || 
                            event.event_category || 
                            'general'
                          )}
                        </span>
                        <div>
                          <div style={{fontSize: '13px', fontWeight: 'bold'}}>
                            {formatEventType(
                              event.payload?.data?.notification_type ||
                              event.payload?.data?.event_type ||
                              event.payload?.webhook_type ||
                              event.event_type ||
                              'unknown'
                            )}
                          </div>
                          <div style={{
                            fontSize: '10px',
                            color: getEventCategoryColor(
                              event.payload?.data?.device_type ||
                              event.payload?.category ||
                              event.event_category ||
                              'general'
                            ).text,
                            fontWeight: 'bold',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                          }}>
                            {getEventCategoryName(
                              event.payload?.data?.device_type ||
                              event.payload?.category ||
                              event.event_category ||
                              'general'
                            )}
                          </div>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell className="small">
                      {(() => {
                        const verkadaTimestamp = event.payload?.created_at ||
                                               event.payload?.data?.created ||
                                               event.payload?.data?.timestamp ||
                                               event.timestamp;
                        const timestamp = verkadaTimestamp > 9999999999 ? verkadaTimestamp : verkadaTimestamp * 1000;
                        return formatTimestampWithTimezone(timestamp);
                      })()}
                    </TableCell>
                    <TableCell className="small">
                      {(() => {
                        const notificationType = event.payload?.data?.notification_type ||
                                               event.payload?.notification_type ||
                                               event.payload?.webhook_type ||
                                               event.payload?.data?.device_type ||
                                               event.payload?.event_type ||
                                               event.event_type ||
                                               event.payload?.type;
                        
                        if (notificationType) {
                          return (
                            <span style={{
                              padding: '2px 8px',
                              backgroundColor: '#f3f4f6',
                              color: '#374151',
                              borderRadius: '4px',
                              fontSize: '12px',
                              fontWeight: 'bold'
                            }}>
                              {notificationType}
                            </span>
                          );
                        } else {
                          return (
                            <span style={{color: '#9ca3af', fontSize: '11px', fontStyle: 'italic'}}>
                              Nicht verfügbar
                            </span>
                          );
                        }
                      })()}
                    </TableCell>
                    <TableCell>
                      {event.actions_triggered && event.actions_triggered.length > 0 ? (
                        <div style={{display: 'flex', flexWrap: 'wrap', gap: '4px'}}>
                          {event.actions_triggered.map((action, idx) => (
                            <span key={idx} style={{
                              padding: '2px 6px',
                              backgroundColor: '#dcfce7',
                              color: '#166534',
                              borderRadius: '4px',
                              fontSize: '11px',
                              fontWeight: 'bold'
                            }}>
                              ✓ {action}
                            </span>
                          ))}
                        </div>
                      ) : (
                        <span style={{color: '#6b7280', fontSize: '12px'}}>{t('audit_no_actions')}</span>
                      )}
                    </TableCell>
                    <TableCell>
                      <details style={{cursor: 'pointer'}}>
                        <summary style={{fontSize: '12px', color: '#6b7280'}}>
                          {t('show_details')} ({Object.keys(event.payload || {}).length} {t('fields')})
                        </summary>
                        <div style={{
                          marginTop: '8px',
                          maxHeight: '300px',
                          overflow: 'auto',
                          backgroundColor: '#f8fafc',
                          borderRadius: '6px',
                          padding: '12px'
                        }}>
                          <table style={{width: '100%', fontSize: '11px', borderCollapse: 'collapse'}}>
                            <thead>
                              <tr style={{borderBottom: '1px solid #e5e7eb'}}>
                                <th style={{textAlign: 'left', padding: '4px 8px', fontWeight: 'bold', color: '#374151'}}>Feld</th>
                                <th style={{textAlign: 'left', padding: '4px 8px', fontWeight: 'bold', color: '#374151'}}>Wert</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Object.entries(event.payload || {}).map(([key, value], idx) => (
                                <tr key={idx} style={{borderBottom: idx % 2 === 0 ? '1px solid #f3f4f6' : 'none'}}>
                                  <td style={{
                                    padding: '6px 8px',
                                    fontWeight: 'bold',
                                    color: '#6b7280',
                                    verticalAlign: 'top',
                                    minWidth: '100px'
                                  }}>
                                    {key}
                                  </td>
                                  <td style={{
                                    padding: '6px 8px',
                                    color: '#1f2937',
                                    verticalAlign: 'top',
                                    wordBreak: 'break-word'
                                  }}>
                                    {typeof value === 'object' ? (
                                      <details style={{cursor: 'pointer'}}>
                                        <summary style={{color: '#6b7280', fontSize: '10px'}}>
                                          {Array.isArray(value) ? `Array (${value.length})` : 'Objekt'}
                                        </summary>
                                        <div style={{
                                          fontSize: '9px',
                                          backgroundColor: '#f9fafb',
                                          padding: '4px',
                                          borderRadius: '3px',
                                          marginTop: '4px',
                                          maxHeight: '100px',
                                          overflow: 'auto',
                                          fontFamily: 'monospace',
                                          whiteSpace: 'pre-wrap'
                                        }}>
                                          {renderJsonWithLinks(value)}
                                        </div>
                                      </details>
                                    ) : (
                                      <div style={{
                                        color: key.toLowerCase().includes('time') || key.toLowerCase().includes('date') ? '#0369a1' :
                                               key.toLowerCase().includes('plate') || key.toLowerCase().includes('license') ? '#dc2626' :
                                               key.toLowerCase().includes('id') ? '#7c3aed' : '#1f2937'
                                      }}>
                                        {renderTextWithLinks(String(value))}
                                      </div>
                                    )}
                                  </td>
                                </tr>
                              ))}
                              {Object.keys(event.payload || {}).length === 0 && (
                                <tr>
                                  <td colSpan={2} style={{
                                    padding: '12px 8px',
                                    textAlign: 'center',
                                    color: '#6b7280',
                                    fontStyle: 'italic'
                                  }}>
                                    {t('audit_no_payload')}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </details>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>

      {/* Real-time Status */}
      {webhookConfig && (
        <Card className="panel lightCard">
          <CardContent>
            <div className="panel-title darktxt" style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
              <span>📊</span>
              Webhook-Status
            </div>
            
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', marginTop: '12px'}}>
              <div>
                <div className="small" style={{color: '#6b7280', marginBottom: '4px'}}>Webhook URL:</div>
                <div style={{
                  fontFamily: 'monospace',
                  fontSize: '11px',
                  padding: '4px 8px',
                  backgroundColor: '#f8fafc',
                  borderRadius: '4px',
                  wordBreak: 'break-all'
                }}>
                  {webhookConfig.webhook_url}
                </div>
              </div>
              
              <div>
                <div className="small" style={{color: '#6b7280', marginBottom: '4px'}}>Status:</div>
                <div style={{display: 'flex', alignItems: 'center', gap: '6px'}}>
                  <span style={{
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    backgroundColor: webhookConfig.enabled ? '#10b981' : '#ef4444'
                  }}></span>
                  <span style={{fontSize: '13px', fontWeight: 'bold'}}>
                    {webhookConfig.enabled ? 'Aktiv' : 'Deaktiviert'}
                  </span>
                </div>
              </div>

              <div>
                <div className="small" style={{color: '#6b7280', marginBottom: '4px'}}>Live-Benachrichtigungen:</div>
                <div style={{display: 'flex', alignItems: 'center', gap: '6px'}}>
                  <span style={{
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    backgroundColor: webhookNotifications.length > 0 ? '#f59e0b' : '#6b7280'
                  }}></span>
                  <span style={{fontSize: '13px'}}>
                    {webhookNotifications.length} ungelesene Events
                  </span>
                </div>
              </div>
            </div>

            {/* Instructions */}
            <div style={{
              marginTop: '16px',
              padding: '12px',
              backgroundColor: '#f0f9ff',
              borderRadius: '6px',
              border: '1px solid #0ea5e9'
            }}>
              <div style={{fontSize: '13px', fontWeight: 'bold', marginBottom: '6px'}}>{t('webhooks_integration_label')}</div>
              <div style={{fontSize: '12px', color: '#6b7280', lineHeight: '1.4'}}>
                1. Kopieren Sie die Webhook-URL aus den Einstellungen<br/>
                2. Konfigurieren Sie diese URL in Verkada unter "Integrations"<br/>
                3. Aktivieren Sie Events für "Person of Interest" und "License Plate Alerts"<br/>
                4. Events erscheinen hier in Echtzeit und lösen automatische Aktionen aus
              </div>
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
